export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    creationTime: other.creationTime || null,
    updatedTime: other.updatedTime || null,
    ip: other.ip || null,
    alias: other.alias || null,
    orgId: other.orgId || null,
  }
}
